import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';
import { StoreListComponent } from '@components/stores-locator/components/store-list';
import { Store, StoresLocator } from '@components/stores-locator/model';
import { GetMarkersPipe } from '@components/stores-locator/pipes';
import { StoresService } from '@components/stores-locator/services';
import { ElasticSearchService } from '@services/elastic-search';
import { StoreQuery } from '@services/elastic-search/models';
import { LogsService } from '@services/logs';
import { ResponsiveService } from '@services/responsive/responsive.service';
import { MapComponent } from '@shared/components/map/map.component';
import { MapService } from '@shared/components/map/services';
import { Observable, take } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-stores-locator',
  imports: [StoreListComponent, MapComponent, GetMarkersPipe, AsyncPipe],
  templateUrl: './stores-locator.component.html',
  styleUrl: './stores-locator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoresLocatorComponent implements OnInit {
  @Input() data!: StoresLocator;
  readonly breakpoints = inject(ResponsiveService).breakpoints;
  isStoreLoaded = signal(false);
  forceZoomOnFeature = signal(false);
  readonly #mapService = inject(MapService);
  isGoogleApiLoaded = this.#mapService.isLoaded;
  readonly #storesService = inject(StoresService);
  stores$: Observable<Store[]> = this.#storesService.getStores$();
  readonly #elasticSearchService = inject(ElasticSearchService);
  readonly #logsService = inject(LogsService);

  constructor() {
    this.#mapService.load();
  }

  ngOnInit(): void {
    const { regionCode, countryCode } = this.data;
    const queryOptions: StoreQuery = {};
    if (regionCode) {
      queryOptions.codeRegion = regionCode;
    }
    if (countryCode) {
      queryOptions.countryCode = countryCode;
    }
    if (regionCode || countryCode) {
      this.forceZoomOnFeature.set(true);
    }
    this.#elasticSearchService
      .getStores(queryOptions)
      .pipe(
        take(1),
        tap((stores) => {
          this.#storesService.setStores(stores);
          this.isStoreLoaded.set(true);
        })
      )
      .subscribe({
        error: (err: unknown) =>
          this.#logsService.error('StoresLocatorComponent', 'Initial store list fetch failed', err),
      });
  }
}
